import { ReactNode } from 'react'
import { GridColumn, RowId } from '../../types/grid.types'
import GridRow from './GridRow'
import SkeletonRows from '../states/SkeletonRows'
import GridEmptyState from '../states/GridEmptyState'

export interface GridBodyProps<T> {
  columns: GridColumn<T>[]
  rows: T[]
  getRowId: (row: T) => RowId
  isLoading?: boolean
  onRowClick?: (row: T) => void
  emptyTitle?: string
  emptySubtitle?: string
  emptyIcon?: ReactNode
}

export const GridBody = <T,>({
  columns,
  rows,
  getRowId,
  isLoading,
  onRowClick,
  emptyTitle,
  emptySubtitle,
  emptyIcon,
}: GridBodyProps<T>) => {
  if (isLoading) {
    return (
      <tbody>
        <SkeletonRows columnCount={columns.length} />
      </tbody>
    )
  }

  if (!rows.length) {
    return (
      <tbody>
        <GridEmptyState
          colSpan={columns.length}
          title={emptyTitle}
          subtitle={emptySubtitle}
          icon={emptyIcon}
        />
      </tbody>
    )
  }

  return (
    <tbody>
      {rows.map((row) => (
        <GridRow
          key={getRowId(row)}
          row={row}
          columns={columns}
          rowId={getRowId(row)}
          onRowClick={onRowClick}
        />
      ))}
    </tbody>
  )
}

export default GridBody
